exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.arretes-compatables th.el-table__cell.gutter {\n  display: none!important;\n}\n", ""]);

// exports
